import useTranslationHook from "../../hooks/useTranslationHook";
import GalleryModal from "./GalleryModal";
import useWindowDimensions from "../../hooks/useWindowDimension";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// import FloorPlanModal from "../../developerProject/projectDetail/FloorPlanModal"; // ADREC: Floor Plan removed
const Gallery = ({ images, isFromMyAuctions = false, onClick }) => {
    const location = useLocation();
    // ADREC: Floor Plan removed — selectedImage state no longer needed.
    // const [selectedImage, setSelectedImage] = useState(null);

    const [activeIndex, setActiveIndex] = useState(null);
    const isSeller = useSelector((state) => state.profile.account);
    const imagesUrls = images?.map(
        (image) =>
            `${process.env.REACT_APP_AZURE_BLOB_URL}${image?.bucket_name}/${image?.doc_file_name}`
    );
    const { t } = useTranslationHook();
    const windowDimension = useWindowDimensions();
    // const noOfSlideToShow =
    //     windowDimension.width <= 991 ? [0] : [0, 1, 2, 3, 4];
    const maxSlides = windowDimension.width <= 991 ? 1 : 5;
    const slidesCount =
        imagesUrls?.length > 0 ? Math.min(maxSlides, imagesUrls.length) : 1;
    const noOfSlideToShow = Array.from({ length: slidesCount }, (_, i) => i);

    const isProjectDetail =
        location.pathname.split("/")[1] === "project-detail";

    const shouldWrapInDiv =
        isProjectDetail || (!isFromMyAuctions && isSeller === 1);

    const wrap = (className) =>
        shouldWrapInDiv ? ["div", { className }] : [React.Fragment, {}];

    const [Container, containerProps] = wrap("container");
    const [Row, rowProps] = wrap("row");
    const [Col, colProps] = wrap("col-md-12");

    return (
        <section className="gallery-wrap">
            <Container {...containerProps}>
                <Row {...rowProps}>
                    <Col {...colProps}>
                        {/* ADREC: Floor Plan button removed — not applicable to
                            land-plot auctions. (floorPlan prop + FloorPlanModal now unused.) */}
                        <div className={`gallery-box count-${noOfSlideToShow.length}`}>
                            {noOfSlideToShow?.map((index) => (
                                <div
                                    key={index}
                                    className={`slide slide-${index + 1} ${noOfSlideToShow.length === 1 ? "shadoww" : ""}`}
                                    onClick={() => setActiveIndex(index)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#gallaryModal"
                                >
                                    <img
                                        className="slide-fixed"
                                        src="/img/slide-1-trans.png"
                                        alt="project"
                                    />
                                    <img
                                        className="slide-img"
                                        // src={
                                        //     imagesUrls[index]
                                        //         ? `${imagesUrls[index]}`
                                        //         : `/img/slide-1.jpg`
                                        // }
                                        src={
                                            imagesUrls[index] ||
                                            "/img/slide-1.jpg"
                                        }
                                        alt="project"
                                    />
                                    {noOfSlideToShow.length - 1 === index && (
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setActiveIndex(null);
                                            }}
                                            className="allpic open-modal-btn"
                                            data-bs-toggle="modal"
                                            data-bs-target={`#gallaryModal`}
                                        >
                                            {t("Show All Photos")}
                                        </button>
                                    )}
                                </div>
                            ))}
                            <GalleryModal
                                modalId={`gallaryModal`}
                                images={
                                    imagesUrls.length > 0
                                        ? imagesUrls
                                        : ["/img/slide-1.jpg"]
                                }
                                activeIndex={activeIndex}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* ADREC: Floor Plan removed. <FloorPlanModal image={selectedImage} /> */}
        </section>
    );
};

export default Gallery;
